import PlatformOrgsPage from "./PlatformOrgsPage";
import CoverageAoisPanel from "./CoverageAoisPanel";
import LicensingPanel from "./components/LicensingPanel";
import PlatformCoveragePage from "./PlatformCoveragePage";
import PlatformDatasetsPage from "./PlatformDatasetsPage";
import OperatingAOIsPage from "./OperatingAOIsPage";
import DatasetCoveragePage from "./DatasetCoveragePage";
import AiDashboardsPage from "./AiDashboardsPage";

export default function PlatformAdminContent({ active }) {
  switch (active) {

    case "datasets":
      return <PlatformDatasetsPage />;

    case "dataset_coverage":
      return <DatasetCoveragePage />;

      case "coverage_aois":
      return <CoverageAoisPanel />;

    case "orgs":
    default:
      return <PlatformOrgsPage />;

    case "operating_aois":
      return <OperatingAOIsPage />;

    case "licensing":
      return <LicensingPanel />;

    case "ai_dashboards":
      return <AiDashboardsPage />;

    case "coverage_imagery":
      return <PlatformCoveragePage />;


  }
}